<template>
  <b-section-loader :loading="$loading.isLoading('getAudit')">
    <b-form
      :readonly="audit.statusId === 3 || !can('audits.update')"
      hide-action-buttons
      @submit="submit">
      <div class="d-flex justify-space-between mb-3">
        <v-btn border color="white" @click="$router.back()">
          <v-icon icon="mdi-chevron-left"></v-icon>
          <span class="font-weight-medium">Назад</span>
        </v-btn>

        <div class="d-flex ga-2 align-center">
          <v-btn
            v-if="audit.statusId !== 3"
            border
            class="border-success border-opacity-50"
            color="white"
            @click="completeAudit">
            <v-icon class="mr-1" color="green-darken-2">mdi-check</v-icon>
            <span class="font-weight-medium text-green-darken-2">
              Завершити аудит
            </span>
          </v-btn>
          <v-btn
            v-if="audit.statusId !== 3 && can('audits.update')"
            :loading="$loading.isLoading('auditUpdate')"
            border
            color="white"
            type="submit">
            <span class="font-weight-medium">Зберегти зміни</span>
          </v-btn>
        </div>
      </div>
      <v-card border>
        <v-card-text>
          <div class="d-flex align-center ga-3">
            <div class="icon--blue">
              <v-icon icon="mdi-file-document-outline" size="23"></v-icon>
            </div>

            <div>
              <div class="font-weight-bold font-size-18 mb-1">
                {{ audit.name }}
              </div>
              <div class="d-flex ga-2">
                <v-chip
                  :style="getColorByStatus(audit.statusId)"
                  border
                  class="font-weight-bold"
                  density="comfortable"
                  rounded="lg"
                  size="small"
                  variant="flat"
                  style="width: max-content">
                  <span class="font-weight-bold">
                    {{ audit.status.name }}
                  </span>
                </v-chip>
                <v-chip color="grey-darken-3" density="compact" rounded="pill">
                  <span class="font-weight-bold text-grey-darken-2"
                    >{{ audit.type.name }} ({{ audit.year }})
                  </span>
                </v-chip>
                <v-divider
                  v-if="audit.statusId === 3"
                  class="mx-1"
                  vertical></v-divider>
                <div
                  v-if="audit.statusId === 3"
                  class="d-flex align-center ga-1">
                  <span
                    class="font-weight-bold text-uppercase text-grey font-size-12">
                    Оцінка
                  </span>
                  <v-chip
                    color="grey-darken-3"
                    density="compact"
                    rounded="pill">
                    <span class="font-weight-bold text-grey-darken-2">{{
                      audit.internalControlAssessment.name
                    }}</span>
                  </v-chip>
                </div>
              </div>
            </div>
          </div>
          <v-divider class="mt-5 mb-4"></v-divider>

          <audit-tabs></audit-tabs>

          <router-view></router-view>
        </v-card-text>
      </v-card>
    </b-form>
  </b-section-loader>
</template>

<script lang="ts">
import { BForm, BSectionLoader } from 'best-modules/components'
import { initAudit } from './index'
import { useCan } from '@/composables/useCan'
import { getColorByStatus } from '../../helpers'
import AuditTabs from './components/Tabs.vue'

export default {
  name: 'AuditSingle',
  components: { AuditTabs, BForm, BSectionLoader },
  methods: { getColorByStatus },
  setup() {
    const { can } = useCan()
    return { ...initAudit(), can }
  },
}
</script>

<style lang="scss" scoped></style>
